import { Pullout, PulloutType } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import _ from 'lodash';
import HtmlParser from 'html-react-parser';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import {
	AudienceStatus,
	DistributionContactsListSourceType,
	IAudience,
	IDistributionContactActionCreators,
	ISurveyAdminSummary,
	ISurveyParticipantActionCreators,
	SurveyStatusType,
} from '../../../models';
import { defaultAudience } from '../../../store/AudienceDetailsStore';
import { IDistributionContactState } from '../../../store/DistributionContactStore';
import { ISurveyParticipantState } from '../../../store/SurveyParticipantStore';
import { DistributionContactsList } from '../../audience/distributions/DistributionContactsList';
import { CardLayout, ClearDiv } from '../../common';

export type IAdminResetResendReopenProps = {
	surveyId: number;
	audienceId: number;
	audiences: IAudience[];
	isLoadingAudiences: boolean;
	GetAudiences: (surveyId: number) => void;
	surveyAdminSummary?: ISurveyAdminSummary;
} & IDistributionContactActionCreators &
	IDistributionContactState &
	ISurveyParticipantActionCreators &
	ISurveyParticipantState;

export const AddResetResendReopenButtonContainer = styled.div`
	position: absolute;
	right: 28px;
`;
AddResetResendReopenButtonContainer.displayName = 'AddResetResendReopenButton';

export const MessageContainer = styled.div`
	height: 39px;
	width: 623px;
	color: #444444;
	font-family: Montserrat;
	font-size: 15px;
	font-weight: 500;
	line-height: 19px;
`;
MessageContainer.displayName = 'MessageContainer';

export class AdminResetResendReopen extends React.PureComponent<IAdminResetResendReopenProps, { audience: IAudience }> {
	constructor(props: IAdminResetResendReopenProps) {
		super(props);

		const audience = _.find(props.audiences, (a) => a.audienceId === props.audienceId) ?? defaultAudience;
		this.state = {
			audience,
		};
	}

	public componentDidMount() {
		this.props.ClearSelectedDistributionContacts();
	}

	public componentDidUpdate(previousProps: IAdminResetResendReopenProps) {
		if (this.props.audiences !== previousProps.audiences) {
			this.setState({ audience: _.find(this.props.audiences, (a) => a.audienceId === this.props.audienceId) ?? defaultAudience });
		}
	}

	public render() {
		const { surveyAdminSummary, surveyId } = this.props;
		const { audience } = this.state;
		const hasBeenCancelled = surveyAdminSummary ? surveyAdminSummary.surveyStatus === SurveyStatusType.Cancelled : false;
		const readOnly = hasBeenCancelled || audience.isClosed;

		return (
			<CardLayout loading={this.props.isLoadingAudiences} title={ContentConstants.SURVEY_ADMIN_ACTION_HEADER_RESET_REOPEN_RESEND}>
				{hasBeenCancelled && (
					<MessageContainer>
						<b>{ContentConstants.SURVEY_ADMIN_IS_CANCEL_NOTE}</b>
						{ContentConstants.SURVEY_ADMIN_IS_CANCEL_CONTENT}
					</MessageContainer>
				)}
				{audience.isClosed && !hasBeenCancelled && (
					<MessageContainer>
						<b>{ContentConstants.SURVEY_ADMIN_IS_CLOSED_NOTE}</b>
						{ContentConstants.SURVEY_ADMIN_IS_CLOSED_CONTENT}
					</MessageContainer>
				)}

				{(audience.audienceStatus === AudienceStatus.Ready || audience.audienceStatus === AudienceStatus.Publishing) && (
					<>
						<Pullout type={PulloutType.Note}>{HtmlParser(ContentConstants.SURVEYPARTICIPANTS_PUBLISHING_NOTE)}</Pullout>
						<ClearDiv clearHeight='30px' />
					</>
				)}
				<DistributionContactsList
					{...this.props}
					distributionContactsListSourceType={DistributionContactsListSourceType.ResetResendReopen}
					readonly={readOnly}
					surveyId={surveyId}
					audienceId={audience.audienceId}
					distributionType={audience.distributionType}
					surveyStatus={SurveyStatusType.Scheduled}
				/>
			</CardLayout>
		);
	}
}
